<template>
	<div>
		<el-breadcrumb separator="/" class="breadcrumb">
			<el-breadcrumb-item :to="{ path: '/setting/service-maintenance' }">{{ $t("router.omelinkUserServiceMaintenance") }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t("serviceMaintenance.serviceMaintenance") }}</el-breadcrumb-item>
		</el-breadcrumb>

		<el-card class="table-card">
			<el-table
				:data="paginatedServiceMaintenanceData"
				v-loading="loading"
				element-loading-text="loading..."
				stripe
				border
				style="width: 100%"

			>
				<el-table-column prop="sort_order" :label="$t('serviceMaintenance.sort')"></el-table-column>

				<el-table-column prop="app_name" :label="$t('serviceMaintenance.applicationName')"></el-table-column>
				<el-table-column prop="merchant_name" :label="$t('serviceMaintenance.businessName')"></el-table-column>

				<el-table-column prop="type" :label="$t('serviceMaintenance.type')">
	                <template slot-scope="scope">
                    	{{ scope.row.type === TypeEnum.SERVICE ? $t("serviceMaintenance.service") : $t("serviceMaintenance.soft") }}
                    </template>
                </el-table-column>lo


				<el-table-column prop="status" :label="$t('serviceMaintenance.status')" width="100">
					<template slot-scope="scope">
						<el-tag :type="scope.row.is_selected ? 'success' : 'danger'" size="mini">
							{{ scope.row.is_selected ? $t("serviceMaintenance.show") : $t("serviceMaintenance.hide") }}
						</el-tag>
					</template>
				</el-table-column>

                <el-table-column :label="$t('serviceMaintenance.operate')" width="200" fixed="right" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" :type="scope.row.is_selected ? '' : 'primary'" @click="handleOperation(scope.row)">{{
                            scope.row.is_selected ? $t("serviceMaintenance.hide") : $t("serviceMaintenance.show")
                            }}</el-button>
                    </template>
                </el-table-column>
			</el-table>

			<div class="pagination-container" v-if="!loading && allServiceMaintenanceData.length > 0">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 50]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="allServiceMaintenanceData.length"
					background
				></el-pagination>
			</div>
		</el-card>
	</div>
</template>

<script>
import { getUserPhoneMerchantList ,postServiceProviderStatus} from "../../services/api-v2/api-v2";

const TypeEnum = {
	SERVICE:1,// 1代表服务，2代表软件
	SOFT:2,
};

const OperationStatusEnum = {
   ATTACH: "attach",//展示
    DETACH: "detach",//屏蔽
};

export default {
	name: "ServiceProviderMaintenance",
	data() {
		return {
            TypeEnum,
            OperationStatusEnum,

			allServiceMaintenanceData: [], // 存储所有数据
			loading: false,
			currentPage: 1,
			pageSize: 20,
			selectedCustomerRow: null,

			phone_number: "",
		};
	},
	created() {
		this.phone_number = this.$route.params.id;
		this.loadServiceProviderMaintenanceList();
	},

	methods: {
		async loadServiceProviderMaintenanceList() {
			this.loading = true;
			try {
				const { data } = await getUserPhoneMerchantList(this.phone_number);

				this.allServiceMaintenanceData = data;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},


		handleCurrentChange(page) {
			this.currentPage = page;

		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
		},
        async handleOperation(row){
            try {
                const newStatus = row.is_selected === true ? OperationStatusEnum.DETACH : OperationStatusEnum.ATTACH;

				await postServiceProviderStatus(row.id, newStatus, this.phone_number);
                this.$message.success(this.$t("serviceMaintenance.successfulOperation"));
                 this.loadServiceProviderMaintenanceList();
			} catch (error) {
				this.$message.error(error);
			}
        }


	},
	computed: {
        // 添加一个计算属性，用于获取当前页显示的数据
        paginatedServiceMaintenanceData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.allServiceMaintenanceData.slice(start, end);
        }
    }
};
</script>
<style scoped>
.table-card {
	margin-top: 20px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.pagination-container {
	margin-top: 20px;
	text-align: right;
}
/* 禁用交互 */
.readonly-checkbox-group {
	pointer-events: none;
	opacity: 1 !important;
}
</style>
